import { CircularProgress } from '@mui/material';
import styled from 'styled-components';

export const RootContainer = styled(CircularProgress)`
  padding: 50px;
  left: 50%;
  position: relative;
  margin: 50px 0;
  transform: translateX(-50%);
  -webkit-animation: none;
  animation: none;
  color: ${({ theme }) => theme.colors.primary};
`;
